var _style, _defs, _path, _path2, _defs2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgListicon = function SvgListicon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n    .st1a{clip-path:url(#SVGID_4_);fill:#fdb03c;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.93,26.66C25,29.94,20.74,32,16,32C7.16,32,0,24.84,0,16S7.16,0,16,0c4.69,0,8.91,2.02,11.83,5.23   c-0.64,0.77-0.99,1.46-1.17,1.9c-0.01,0.01-0.01,0.02-0.01,0.03c-0.31-0.39-0.65-0.76-1-1.1c-0.01-0.01-0.02-0.02-0.03-0.03   c-2.46-2.44-5.83-3.93-9.54-3.93c-0.07,0-0.14,0-0.2,0h-0.02c-0.59,0-1.16,0.05-1.71,0.14c-0.78,0.11-1.54,0.29-2.27,0.53   C6.09,4.5,1.9,9.86,1.9,16.2c0,7.76,6.29,14.04,14.04,14.04c4.39,0,8.31-2.01,10.89-5.17C27.11,25.63,27.5,26.17,27.93,26.66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,16c0,3.39-1.05,6.53-2.85,9.12c-0.45-0.57-0.83-1.19-1.15-1.84c1.26-2.1,1.98-4.57,1.98-7.2   c0-2.65-0.73-5.13-2.01-7.24c0.33-0.68,0.73-1.33,1.2-1.92C30.96,9.5,32,12.63,32,16"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 10.23,
    y: 10.23,
    width: 11.53,
    height: 11.53
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1a",
    d: "M16,10.23c-3.18,0-5.77,2.58-5.77,5.77c0,3.18,2.58,5.77,5.77,5.77c3.19,0,5.77-2.58,5.77-5.77   C21.77,12.81,19.19,10.23,16,10.23 M16,19.89c-2.15,0-3.89-1.74-3.89-3.89c0-2.15,1.74-3.89,3.89-3.89c2.15,0,3.89,1.74,3.89,3.89   C19.89,18.15,18.15,19.89,16,19.89"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/listicon.866b58db.svg";
export { ForwardRef as ReactComponent };